import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import * as FileSaver from 'file-saver';
import { Observable } from 'rxjs/Observable';

import { CBMError, Task } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const fileDownloadUrl = taskId => `${environment.apiUrl}/download/${taskId}`;

@Injectable()
export class DownloadService {
  public isDownloading = false;

  constructor(private readonly httpService: HttpService) {}

  public downloadFile(task: Task) {
    console.log(task);
    const downloadFile: Observable<Response> = this.httpService.getFile(fileDownloadUrl(task.id));
    this.saveFile(downloadFile);
  }

  private saveFile(downloadFile: Observable<Response>): void {
    let errorMessages: CBMError[];
    downloadFile.subscribe(
      (res: Response) => {
        console.log(res);
        const contentDisposition = res.headers.get('content-disposition');
        console.log(res.headers.get('content-disposition'));
        const filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/gi, '');
        console.log(filename);
        FileSaver.saveAs(res.blob(), filename);
      },
      (errors: CBMError[]) => {
        console.log(errors);
        errorMessages = errors;
        console.log(errorMessages);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/download.service.ts